<div class="document">
    <div class="header-section">
        <h1>FAQ</h1>
    </div>

    <p class="faq-heading">How do I personalize my app to display my company logo, description, location and hours of operation?</p>
    <p>Logo, description, website, social media accounts and custom links can be set in the <b>Info</b> tab.</p>
    <p>Location(s) and hours can be set in the <b>Locations</b> tab.</p>

    <p class="faq-heading">How can I make sure my images will show up correctly in the app?</p>
    <p>When uploading images for various categories such as News or Events, a minimum or recommended size will be displayed on the upload window.</p>

    <p class="faq-heading">When I upload my image nothing happens?</p>
    <p>Please verify the image type you are trying to upload. Images should be either a PNG, JPG or BMP, and no larger than 4MB.</p>

    <p class="faq-heading">Can I upload a MP4 file as a video?</p>
    <p>Vimeo and YouTube videos are supported. Videos can be added by selecting an album, and enter the URL to the video you want to share in the app.</p>

    <p class="faq-heading">My event is showing up in the calendar but not in the newsfeed, why?</p>
    <p>In order for events to display within the newsfeed, the option “Display in News Feed” must be check marked. Also make sure the publish date is correct.</p>

    <p class="faq-heading">My social media posts are not displayed chronologically in the newsfeed – why?</p>
    <p>News and events created in the admin content management portal are prioritized to be displayed 72 hours ahead of social media posts.</p>

    <p class="faq-heading">How do I set up user / membership types in the portal?</p>
    <p>Use / Membership types can be added or edited in the <b>Users</b> tab. Click on the button “User Types” (upper right).
        By default, "members / parents" and "staff" are already created.</p>

    <p class="faq-heading">Can I edit user information in the portal? How?</p>
    <p>Yes, an individual’s info can be edited by selecting a user within the <b>Users</b> tab.
        From there, click “Edit” and then “Save” once all modifications are made.</p>

    <p class="faq-heading">How do I create guest access for non-members?</p>
    <p>Go to the <b>Users</b> tab. Click on “Add” to begin creating a guest account.
        Enter Guest as the “first name” and User as the “last name”, in the “email” field add an email address guest&#64;xxx.com.
        For example, the email guest&#64;myapp.com. Once the guest email is created, the password is automatically set to “guest” and the account is ready for use.
    </p>

    <p class="faq-heading">What is the cancellation policy?</p>
    <p>Terms and conditions can be found by clicking on the "Terms and Cond." link at the bottom left of this site.</p>

    <p class="faq-heading">Who do I contact for help?</p>
    <p>Please contact <a href="mailto:support@1218team.com">support&#64;1218team.com</a> for help.</p>
</div>
